import { DELIVER as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    refreshBtn: false,
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      { label: LABELS.deliveryNoteNumber, prop: 'deliveryNoteNumber', search: true },
      { label: LABELS.deliveryNoteLineNumber, prop: 'noteItemNumber' },
      { label: LABELS.materialNumber, prop: 'materialNumber', search: true },
      { label: LABELS.materialDescription, prop: 'materialDesc', search: true },
      { label: LABELS.numberOfVouchers, prop: 'voucherQuantity' },
      { label: LABELS.orderNumber, prop: 'orderNumber', search: true },
      { label: LABELS.orderLineNumber, prop: 'orderItemNumber' },
      { label: LABELS.sendQuantity, prop: 'sendDeliveryNoteQuantity' },
      { label: LABELS.remainingAmount, prop: 'remainNoteQuantity' }
    ]
  }
};
